import {FC, memo} from "react";
import {Box, Container, Heading, Spacer, Text} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

type Props = {

}

export const Home: FC<Props> = memo((props) => {
    const {t} = useTranslation();
    return (
        <Container pt="5">
            <Heading size="xl">{t("home.title")}</Heading>
            <Box pl="5" pt="5">
                <Text fontSize={24}>{t("home.message")}</Text>
            </Box>
            <Box pl="5" pt="5">
                <Text>{t("home.message2")}</Text>
            </Box>
        </Container>
    );
});